/**
 * Reusable copy service for handling clipboard operations
 */

export const copyToClipboard = async (text) => {
  try {
    // Modern clipboard API (preferred)
    if (
      typeof navigator !== "undefined" &&
      navigator.clipboard &&
      window.isSecureContext
    ) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers or non-secure contexts
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      return true;
    }
  } catch (error) {
    console.error("Failed to copy text: ", error);
    return false;
  }
};

export const handleCopyClick = async (text, partnerId, setCopiedId) => {
  const success = await copyToClipboard(text);
  if (success) {
    setCopiedId(partnerId);
    setTimeout(() => setCopiedId(null), 2000);
  }
};